import { computable, mix, observable } from "@chorda/core";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { Card, LevelLayout, Link, Tab, Tabs, Title } from "chorda-bulma";
import { Custom } from "../utils";
import { Action } from "./Action";
import { CodeBox } from "./CodeBox";
import { FaIcon } from "./FaIcon";
const withSelectedComponents = (props) => {
    return props;
};
export const Example = (props) => {
    const files = props.files || [{ name: 'index.ts', code: props.code }];
    return mix(Card, {
        css: 'example-box',
        components: {
            header: false,
            customHeader: true,
            content: true,
            code: false
        },
        templates: {
            customHeader: Custom({
                weight: -10,
                css: 'example-box-header card-header',
                as: LevelLayout([{
                        title: Title({
                            css: 'example-box-title',
                            size: 'is-6',
                            text$: (scope) => scope.title,
                            as: {
                                templates: {
                                    externalLink: props.link && FaIcon({
                                        icon: faExternalLinkAlt,
                                        as: Link({
                                            link: props.link,
                                            text$: () => null,
                                            target: '_blank'
                                        })
                                    })
                                }
                            }
                        })
                    }, {
                        tools: {
                            css: 'example-box-tools',
                            templates: {
                                code: Action({
                                    css: 'is-muted',
                                    icon: 'fas fa-code',
                                    onClick: (e, { isShowCode }) => {
                                        isShowCode.$value = !isShowCode.$value;
                                    }
                                })
                            }
                        }
                    }])
            }),
            content: {
                css: 'example-box-content',
                templates: {
                    content: props.content
                }
            },
            description: {
                css: 'example-box-description',
                weight: -10,
                templates: {
                    content: props.description
                }
            },
            code: {
                weight: -5,
                css: 'code-panel example-box-code',
                templates: {
                    content: withSelectedComponents({
                        templates: files === null || files === void 0 ? void 0 : files.reduce((acc, file) => {
                            acc[file.name] = CodeBox({
                                code: file.code
                            });
                            return acc;
                        }, {}),
                        reactions: {
                            selected: (v) => ({ components: v })
                        },
                        injections: {
                            selected: (ctx) => computable(() => {
                                return files === null || files === void 0 ? void 0 : files.reduce((acc, file) => {
                                    acc[file.name] = file.name == ctx.activeFile;
                                    return acc;
                                }, {});
                            })
                        },
                    }),
                    tabs: Custom({
                        css: 'code-tabs',
                        weight: -1,
                        as: Tabs({
                            tabs: files === null || files === void 0 ? void 0 : files.map(file => Tab({ text: file.name, name: file.name })),
                            defaultTab: Tab({
                                active$: (scope) => computable(() => {
                                    return scope.activeFile == scope.name;
                                }),
                                onClick: (e, scope) => {
                                    scope.activeFile = scope.name;
                                }
                            })
                        }),
                    })
                }
            }
        },
        reactions: {
            isShowCode: (v) => ({ components: { code: v } })
        },
        injections: {
            title: props.title$ || (() => observable(props.title)),
            isShowCode: () => observable(false),
            activeFile: () => observable(files ? files[0].name : null)
            //            content: () => observable(props.content)
        }
    });
};
